var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!['/privacy_policy'].includes(_vm.$route.path))?_c('MyHeaderVue'):_vm._e(),_c('router-view'),(!['/privacy_policy'].includes(_vm.$route.path))?_c('MyFooterVue'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }